import { render, staticRenderFns } from "./data.vue?vue&type=template&id=2b9484b0&scoped=true"
import script from "./data.vue?vue&type=script&lang=ts"
export * from "./data.vue?vue&type=script&lang=ts"
import style0 from "./data.vue?vue&type=style&index=0&id=2b9484b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9484b0",
  null
  
)

export default component.exports